module.exports = __webpack_public_path__ + "static/img/BJYS6.b0d6fa51.png";